"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class RoomSelect extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  makeOption(key, val) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: val,
      value: key
    }, val);
  }
  makeOptions() {
    const {
      RoomTypes
    } = this.props;
    return Object.keys(RoomTypes).map(i => {
      const text = RoomTypes[i];
      return this.makeOption(i, text);
    });
  }
  handleChange(e) {
    if (typeof this.props.changeCallback === 'function') {
      this.props.changeCallback(e);
    }
  }
  render() {
    const {
      secondRoom,
      secondRoomText,
      activeRoom,
      name,
      extraOptionText,
      id
    } = this.props;
    const rooms = this.makeOptions();
    const secondRoomOption = secondRoom && this.makeOption('', secondRoomText);
    const extraOption = extraOptionText && this.makeOption('', extraOptionText);
    const trackName = 'roomtype_' + name.match(/\d+/)[0];
    return /*#__PURE__*/_react.default.createElement("select", {
      onChange: this.handleChange,
      name: name,
      id: id,
      className: "form-control",
      defaultValue: activeRoom,
      "data-hxtrack-name": trackName
    }, secondRoomOption, extraOption, rooms);
  }
}
RoomSelect.propTypes = {
  activeRoom: _propTypes.string,
  name: _propTypes.string,
  secondRoomText: _propTypes.string,
  secondRoom: _propTypes.bool,
  RoomTypes: _propTypes.object.isRequired,
  extraOptionText: _propTypes.string,
  changeCallback: _propTypes.func,
  id: _propTypes.string
};
RoomSelect.defaultProps = {
  activeRoom: 'D20',
  secondRoomText: 'No, thank you',
  secondRoom: false
};
var _default = exports.default = RoomSelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/components/rooms-dropdown.js
// module id = 479
// module chunks = 119